import * as firebase from "firebase/app";

const firebaseP =  firebase.firestore().enablePersistence()
.catch(function(err) {
      if (err.code === 'failed-precondition') {
          console.log("  Multiple tabs open, persistence can only be enabled ,  in one tab at a a time.")
         
      } else if (err.code === 'unimplemented') {
        console.log("The current browser does not support all of the features required to enable persistence ")
      }
  });
console.log("Offline Persistance has been enabled")
export default firebaseP;